import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule, isDevMode } from '@angular/core';
import {
  DefaultFallbackStrategy,
  DefaultInterceptor,
  DefaultMissingHandler,
  FunctionalTranspiler,
  TRANSLOCO_CONFIG,
  TRANSLOCO_LOADER,
  Translation,
  TranslocoLoader,
  TranslocoModule,
  provideTranslocoFallbackStrategy,
  provideTranslocoInterceptor,
  provideTranslocoMissingHandler,
  provideTranslocoTranspiler,
  translocoConfig,
} from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}

export function getDateLocale() {
  return window.localStorage.getItem('preferredLanguage') || 'en';
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: ['en', 'fr', 'es', 'cn', 'ru', 'nl'],
        defaultLang: 'en',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      }),
    },
    { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader },
    provideTranslocoTranspiler(FunctionalTranspiler),
    provideTranslocoMissingHandler(DefaultMissingHandler),
    provideTranslocoInterceptor(DefaultInterceptor),
    provideTranslocoFallbackStrategy(DefaultFallbackStrategy),
  ],
})
export class TranslocoRootModule {}
